<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/info' }">账户设置</el-breadcrumb-item>
            <el-breadcrumb-item>{{ ($route.query.handler*1===1) ? '修改' : '添加' }}成员账户</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="detail-box">
            <div class="detail-item">
                <div class="item-title">
                    {{ ($route.query.handler*1===1) ? '修改' : '添加' }}成员账户
                </div>
                <div class="form-box">
                    <el-form
                        class="form__center"
                        label-width="82px"
                        size="small"
                        style="width: 360px;margin: 0 auto;"
                    >
                        <el-form-item label="姓名：">
                            <el-input
                                v-model="formItem.real_name"
                                placeholder="请输入姓名"
                            />
                        </el-form-item>
                        <el-form-item label="登录账号：">
                            <el-input
                                v-model="formItem.username"
                                placeholder="请登录账号"
                            />
                        </el-form-item>
                        <el-form-item label="手机号：">
                            <el-input
                                v-model="formItem.phone"
                                placeholder="请输入手机号"
                            />
                        </el-form-item>
                        <el-form-item label="邮箱：">
                            <el-input
                                v-model="formItem.email"
                                placeholder="请输入邮箱"
                            />
                        </el-form-item>
                        <el-form-item label="角色权限：">
                            <el-select v-model="formItem.role_id" placeholder="请选择角色">
                                <el-option
                                    v-for="(item, index) in roleList"
                                    :key="index"
                                    v-if="item.role_id !== 1"
                                    :label="item.name"
                                    :value="item.role_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                class="btn-standard"
                                type="primary"
                                @click="onSubmit"
                                v-if="$route.query.handler*1===1"
                            >
                                确认修改
                            </el-button>
                            <el-button
                                class="btn-standard"
                                type="primary"
                                @click="addMember"
                                v-else
                            >
                                确认添加
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import qs from 'qs'
import router from '@/router'

export default {
    name: 'Main',
    data () {
        return {
            handler: 0,
            info: {},
            roleList: [],
            formItem: {
                real_name: '',
                username: '',
                phone: '',
                email: '',
                role_id: ''
            }
        }
    },
    computed: {
        errors () {
            return this.$vuerify.$errors
        }
    },
    vuerify: {
        'formItem.phone': [
            {
                test: /^[\s\S]*.*[^\s][\s\S]*$/,
                message: '请输入手机号'
            }, {
                test: /^1[3456789]\d{9}$/,
                message: '请输入正确的手机号'
            }
        ],
        'formItem.username': [
            {
                test: /^[\s\S]*.*[^\s][\s\S]*$/,
                message: '请输入登录账号'
            },
            {
                test: /^[a-zA-Z0-9_-]{6,18}$/,
                message: '登录账号为6-18位的数字、字母或_组成'
            }
        ],
        'formItem.real_name': {
            test: /^[\s\S]*.*[^\s][\s\S]*$/,
            message: '请输入姓名'
        },
        'formItem.email': [
            {
                test: /^[\s\S]*.*[^\s][\s\S]*$/,
                message: '请输入邮箱'
            },
            {
                test: /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/,
                message: '请输入正确的邮箱'
            }
        ]
    },
    mounted () {
        this.handler = this.$route.query.handler * 1
        this.getRoleList()
        if (this.handler === 1) {
            this.getInfo()
        }
    },
    methods: {
        getInfo () {
            this.$http.get('/api/user/getuserinfo', {
                params: {
                    id: this.$route.query.id
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        this.info = res.data
                        this.formItem = {
                            real_name: res.data.real_name,
                            username: res.data.username,
                            email: res.data.email,
                            phone: res.data.phone,
                            role_id: res.data.role_id
                        }
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        },
        getRoleList () {
            this.$http.get('/api/user/rbac/rolelist')
                .then(res => {
                    if (res.code === 0) {
                        this.roleList = res.data.listData
                    } else {
                        this.$message.warning(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                    // this.$message.warning(res.message)
                })
        },
        onSubmit () {
            if (!this.$vuerify.check()) {
                if (typeof (this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]]) !== 'string') {
                    this.$message.error(this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]][0])
                } else {
                    this.$message.error(this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]])
                }
            } else {
                this.$http.post('/api/user/useredit', qs.stringify({
                    id: this.$route.query.id,
                    ...this.formItem
                }))
                    .then(res => {
                        if (res.code === 0) {
                            this.$notify.success({
                                title: '通知',
                                message: '账户信息更新成功'
                            })
                            router.replace('/index/info/members')
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.error(err)
                    })
            }
        },
        addMember () {
            if (!this.$vuerify.check()) {
                if (typeof (this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]]) !== 'string') {
                    this.$message.error(this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]][0])
                } else {
                    this.$message.error(this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]])
                }
            } else {
                this.$http.post('/api/user/useradd', qs.stringify({
                    ...this.formItem
                }))
                    .then(res => {
                        if (res.code === 0) {
                            this.$notify.success({
                                title: '通知',
                                message: '账户添加成功'
                            })
                            router.replace('/index/info/members')
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.error(err)
                    })
            }
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/var";
    @import "../../assets/style/sub";

    .form-box {
        border-top: 1px solid $--color-border-base;
        margin-top: 0 !important;
    }
</style>
